module.exports = __webpack_public_path__ + "static/media/18ECA44.758b1c01.jpg";